import nexus from 'nexus'
import thunkWrapper from 'redux/thunks/thunkWrapper'

const callChangePassword = async (_, oldPassword, newPassword) => {
  await nexus.auth.changePassword(oldPassword, newPassword)
}

export default thunkWrapper(callChangePassword)
